module.exports = __webpack_public_path__ + "static/ltc-planning-hero.c8623a52.webp";